/**
 * Checks if a value is not null or undefined.
 *
 * This function is a type guard that ensures the given value is neither null nor undefined.
 * It can be used to narrow the variable to a non-nullable type.
 *
 * @template T - The type of the value being checked.
 * @param {T} value - The value to check.
 * @returns {value is NonNullable<T>} - Returns true if the value is not null or undefined, otherwise false.
 */
export const isNotNull = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined;
